var percentageBarValue = {
    base: {
        color: "black.60",
        display: "flex",
        font: "sm",
        justifyContent: "space-between",
        marginBottom: 1,
    },
};
var percentageBarTitle = {
    base: {
        color: "black.100",
    },
};

export { percentageBarTitle, percentageBarValue };
//# sourceMappingURL=percentage-bar.js.map
